import MetaHead from '../components/MetaHead';
import ContactForm from '../components/ContactForm';

export default function ContactPage() {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 space-y-12">
      <MetaHead 
        title="Kontakt - Din Privat Psykolog"
        description="Privat psykolog, 20 års erfaring, Klinisk psykolog i Syddanmark, Autoriseret psykolog med bred klinisk erfaring, Samtaleterapi med individuelle, samtaleterapi, parterapi, psykologhjælp,  "
        ogTitle="Kontakt klinikken - Din Privat Psykolog"
        ogDescription="Privat psykolog, 20 års erfaring, Klinisk psykolog i Syddanmark, Autoriseret psykolog med bred klinisk erfaring, Samtaleterapi med individuelle, samtaleterapi, parterapi, psykologhjælp,  "
        ogImage="https://assets.auxodev.dk/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/7f0d58f1-d94f-4b01-b1cd-7d855932c06a.jpg"
      />

      {/* Header */}
      <div className="border-b border-[#E0D7C6] pb-8 space-y-3">
        <h1 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#5f7365]">
          Kontakt privatklinikken
        </h1>
        <p className="text-base sm:text-lg text-[#3B4D42] max-w-3xl leading-relaxed">
          Du er meget velkommen til at kontakte mig, så du på den måde kan mærke efter, om det er mig, der skal være din privatpsykolog. Det er jo et personbåret fag. Derfor er det rette match også afgørende for terapiens effekt.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-start">
        
        {/* Left Column: Form & Info */}
        <div className="lg:col-span-7 space-y-8">
          
          <div className="flex items-start gap-3 text-xs sm:text-sm text-[#5f7365]">
            <i className="fa-regular fa-info-circle text-[#5f7365] text-lg mt-0.5 shrink-0" />
            <p>
              <strong>Aktuel ventetid:</strong> Aktuelt er der mellem 3-6 ugers ventetid med mulighed for at komme på en afbudsliste.
            </p>
          </div>

          <ContactForm />

        </div>

        {/* Right Column: Contact Cards & Map/Parking */}
        <div className="lg:col-span-5 space-y-6">
          
          <div className="space-y-6">
            <h2 className="font-serif font-bold text-xl text-[#5f7365]">
              Praktiske kontaktoplysninger
            </h2>

            <div className="space-y-4 text-sm text-[#384A3F]">
              
              <div className="flex items-start gap-3.5">
                <i className="fa-regular fa-location-dot text-[#5f7365] text-lg mt-0.5 shrink-0" />
                <div>
                  <p className="font-medium text-[#5f7365]">Torvegade 8, 1. sal</p>
                  <p>6510 Gram, Syddanmark</p>
                </div>
              </div>

              <div className="flex items-start gap-3.5 border-t border-[#EDE6D8] pt-4">
                <i className="fa-regular fa-phone text-[#5f7365] text-lg mt-0.5 shrink-0" />
                <div>
                  <a href="tel:29921879" className="font-bold text-[#5f7365] hover:text-[#4e6053] text-base whitespace-nowrap">
                    <span className="whitespace-nowrap">29 92 18 79</span>
                  </a>
                  <p className="text-xs text-[#52685B] mt-0.5">
                    Telefontid: 12.45 - 13.00 hverdage (undtagen onsdage)
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3.5 border-t border-[#EDE6D8] pt-4">
                <i className="fa-regular fa-envelope text-[#5f7365] text-lg mt-0.5 shrink-0" />
                <div>
                  <a href="mailto:kontakt@dinprivatpsykolog.dk" className="font-medium text-[#5f7365] hover:text-[#4e6053] whitespace-nowrap">
                    <span className="whitespace-nowrap">kontakt@dinprivatpsykolog.dk</span>
                  </a>
                </div>
              </div>

            </div>
          </div>

          {/* Map Link Box */}
          <div className="space-y-3 pt-6 border-t border-[#EDE6D8]">
            <h3 className="font-serif font-bold text-base text-[#5f7365]">
              Find vej til klinikken i Gram
            </h3>
            <div className="overflow-hidden border border-[#EDE6D8] shadow-xs">
              <img
                src="https://assets.auxodev.dk/cdn-cgi/image/width=600,quality=85,format=auto/assets/9bc67d49-c1ad-4360-8231-e9811640bce9/7f0d58f1-d94f-4b01-b1cd-7d855932c06a.jpg"
                alt="Klinikken på Torvegade 8, Gram"
                className="w-full h-40 object-cover"
              />
            </div>
            <p className="text-xs text-[#52685B] leading-relaxed">
              Klinikken ligger centralt i Gram på Torvegade 8, 1. sal i rødstensvillaen. Indgang sker igennem den grønne havelåge, op ad flisegangen til døren mærket <em>Privatpsykolog</em>.
            </p>
            <a
              href="https://www.google.com/maps/search/?api=1&query=Din+Privat+Psykolog,+Torvegade+8,+6510+Gram"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 py-2.5 px-4 bg-[#F8F5EE] hover:bg-white border border-[#D5CEBF] text-xs font-semibold text-[#5f7365] transition-all duration-200 hover:-translate-y-1 rounded-none shadow-2xs w-full justify-center"
            >
              <i className="fa-regular fa-map-location-dot text-[#5f7365]" />
              <span>Åbn Din Privat Psykolog på Google Maps</span>
              <i className="fa-regular fa-arrow-up-right-from-square text-[10px]" />
            </a>
          </div>

        </div>

      </div>
    </div>
  );
}
